import { css } from '@emotion/core';
import { variables } from '@domain-group/fe-brary';
var multipleListingCardPriceFontSize = '18px';
var ellipsisDetails = {
  name: "9y42th",
  styles: "width:100%;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;"
};
var _ref = {
  name: "v0j8y1",
  styles: "height:152px;"
};
export var multipleListingCard = _ref3 => {
  var hasInspection = _ref3.hasInspection;
  return /*#__PURE__*/css("display:flex;position:relative;border:1px solid ", variables.colour.neutral200, ";width:400px;height:140px;", hasInspection && _ref, " &:not(:first-of-type){margin-top:17px;}");
};
export var watchlistButton = {
  name: "qyxk0z",
  styles: "position:absolute;right:13px;z-index:5;"
};
export var nextInspection = /*#__PURE__*/css("position:absolute;bottom:0;font-family:", variables.font.bodyFontFamily, ";font-size:", variables.font.smallFontSize, ";color:", variables.colour.neutral700, ";background-color:", variables.colour.neutral200, ";text-align:left;height:24px;width:100%;padding:0 16px;");
export var nextInspectionLabel = /*#__PURE__*/css("font-weight:", variables.font.headingFontWeight, ";");
export var multipleCardDetails = /*#__PURE__*/css("display:inline-block;background-color:", variables.colour.white, ";color:", variables.colour.black, ";padding:8px 0 0 12px;height:auto;width:auto;max-width:230px;");
export var multipleCardDetailsOuter = {
  name: "1uh2x2k",
  styles: "position:relative;height:126px;"
};
export var multipleCardDetailsPrice = /*#__PURE__*/css(ellipsisDetails, " color:", variables.colour.neutral700, ";font-family:", variables.font.headingFontFamily, ";font-size:", multipleListingCardPriceFontSize, ";font-weight:", variables.font.headingFontWeight, ";line-height:", variables.font.baseLineHeight, ";max-width:175px;");
var _ref2 = {
  name: "unqxrm",
  styles: "right:14px;"
};
export var multipleCardDetailsAgencyLogoContainer = _ref4 => {
  var isScrollable = _ref4.isScrollable;
  return /*#__PURE__*/css("position:absolute;right:0;top:114px;height:24px;", isScrollable && _ref2);
};
export var multipleCardDetailsAgencyLogo = {
  name: "1fh1akf",
  styles: "height:100%;width:auto;max-width:150px;object-fit:cover;"
};
export var agencyDetailsType = {
  name: "j4ssc0",
  styles: "margin-top:9px;"
};
export var link = {
  name: "ytumd6",
  styles: "text-decoration:none;"
};